module.exports = __webpack_public_path__ + "img/logo_marketing.f4ff56bc.png";